import React from 'react';
import { Button } from './ui/button';
import { Users, Award, Shield } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="relative pt-24 pb-16 md:pt-32 md:pb-24" style={{ backgroundColor: 'var(--color-accent-coconut)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1
                className="text-5xl md:text-6xl font-bold leading-tight"
                style={{ color: 'var(--text-base)' }}
              >
                Fresh, Homemade Food for Every Event
              </h1>
              <p
                className="text-xl md:text-2xl"
                style={{ color: 'var(--text-subtle-light)' }}
              >
                Professional catering in Chadderton, Oldham. From intimate gatherings to grand celebrations.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                style={{ backgroundColor: 'var(--accent-ui-accent)', color: 'white' }}
                className="text-lg px-8 py-6"
              >
                Request a Quote
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => document.getElementById('menu').scrollIntoView({ behavior: 'smooth' })}
                className="text-lg px-8 py-6"
                style={{ borderColor: 'var(--accent-ui-accent)', color: 'var(--accent-ui-accent)' }}
              >
                View Menu
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Shield size={32} style={{ color: 'var(--accent-ui-accent)' }} />
                </div>
                <div className="font-bold text-2xl" style={{ color: 'var(--text-base)' }}>5 Star</div>
                <div className="text-sm" style={{ color: 'var(--text-subtle-light)' }}>Food Hygiene</div>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Users size={32} style={{ color: 'var(--accent-ui-accent)' }} />
                </div>
                <div className="font-bold text-2xl" style={{ color: 'var(--text-base)' }}>100+</div>
                <div className="text-sm" style={{ color: 'var(--text-subtle-light)' }}>Events Catered</div>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Award size={32} style={{ color: 'var(--accent-ui-accent)' }} />
                </div>
                <div className="font-bold text-2xl" style={{ color: 'var(--text-base)' }}>4.9★</div>
                <div className="text-sm" style={{ color: 'var(--text-subtle-light)' }}>Customer Rating</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXJnZXIlMjBmcmllc3xlbnwwfHx8fDE3NjkxNDkxNDB8MA&ixlib=rb-4.1.0&q=85"
                alt="Delicious burger and fries"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Floating badge */}
            <div
              className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6"
              style={{ border: '2px solid var(--accent-ui-accent)' }}
            >
              <div className="text-center">
                <div className="font-bold text-3xl" style={{ color: 'var(--accent-ui-accent)' }}>£6-£12</div>
                <div className="text-sm" style={{ color: 'var(--text-subtle-light)' }}>Per Person</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;